import { Injectable, inject, signal } from '@angular/core';
import { HttpClient } from '@angular/common/http';

@Injectable({
    providedIn: 'root',
})
export class IngestionService {
    private readonly http = inject(HttpClient);

    private readonly baseUrl = '/api/v1';

    readonly manualUploadEnabled = signal(false);
    readonly seedExportEnabled = signal(false);

    loadManualUploadEnabled(): void {
        this.http
            .get<{ enabled: boolean }>(
                `${this.baseUrl}/ingestion/manual-upload-enabled`,
            )
            .subscribe({
                next: (response) => {
                    this.manualUploadEnabled.set(
                        response.enabled,
                    );
                },
            });
    }

    loadSeedExportEnabled(): void {
        this.http
            .get<{ enabled: boolean }>(
                `${this.baseUrl}/seed/seed-export-enabled`,
            )
            .subscribe({
                next: (response) => {
                    this.seedExportEnabled.set(
                        response.enabled,
                    );
                },
            });
    }
}